import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 部门列表
import depTree from '@/components/dep-tree';
// 部门列表
import jobSelect from '@/components/jobSelect';
import UpdateProbationRadio from '@/components/probation-status-radio.vue';
// 同意接口
import { inviteApproval } from 'api/settings';
import { getRegularEnv } from 'api/dashboard';
import { sysInfoFn as _sysInfoFn, getCallTypeUrlMethod } from 'api/org/per';
import { v4 as uuidv4 } from 'uuid';
export default {
  components: {
    depTree: depTree,
    jobSelect: jobSelect
  },
  data: function data() {
    var slef = this;
    /**
     *  1. 结算类型列表
     *  2. 发薪方式列表
     */
    return {
      salaryList: [],
      settlemenList: [],
      callTypeList: [],
      visible: false,
      dataForm: {
        department_name: '',
        department_id: '',
        job_title_id: '',
        hire_date: '',
        formal_date: '',
        salary_method: '',
        settlement_type: '',
        probation_day: ''
      },
      cDataForm: {},
      dataRule: {
        first_name: [{
          required: true,
          message: this.$t('323'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 30,
          message: this.$t('invite_6'),
          trigger: 'blur'
        }],
        call_type: [{
          required: true,
          message: this.$t('221'),
          trigger: 'change'
        }],
        last_name: [{
          required: true,
          message: this.$t('1049'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 35,
          message: this.$t('invite_5'),
          trigger: 'blur'
        }],
        department_name: [{
          required: true,
          message: this.$t('877')
        }],
        hire_date: [{
          required: true,
          message: this.$t('790'),
          trigger: 'change'
        }],
        salary_method: [{
          required: true,
          message: this.$t('827'),
          trigger: 'change'
        }],
        settlement_type: [{
          required: true,
          message: this.$t('827'),
          trigger: 'change'
        }]
      },
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          // 离职日期、转正日期、停职日期在hire_date之后可以选择
          var hire_date = new Date(slef.dataForm.hire_date).getTime() - 86400000;
          return time.getTime() < hire_date;
        }
      },
      popover: false
    };
  },
  methods: {
    init: function init(item) {
      var _this = this;
      item.formal_state = !item.formal_state || item.formal_state === '0' ? '1' : item.formal_state;
      this.visible = true;
      this.dataForm = _objectSpread(_objectSpread(_objectSpread({}, this.dataForm), item), {}, {
        department_name: '',
        department_id: '',
        job_title_id: ''
      });
      // 获取称谓列表
      getCallTypeUrlMethod().then(function (res) {
        return _this.callTypeList = res && res.data;
      });
      this.sysInfoFn();
      // 获取试用期天数
      getRegularEnv({
        code: 'STAFF_PROBATION_DAY'
      }).then(function (res) {
        if (res && res.code && !_this.dataForm.probation_day) _this.dataForm.probation_day = res.data;
      });
      this.cDataForm = JSON.parse(JSON.stringify(this.dataForm));
      this.$nextTick(function () {
        _this.$refs.dataForm.resetFields();
      });
    },
    // 获取选项
    sysInfoFn: function sysInfoFn() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _sysInfoFn();
            case 2:
              res = _context.sent;
              if (res && res.code === 1) {
                _this2.salaryList = res.data.salary_method;
                _this2.settlemenList = res.data.settlement_type;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 出生日期禁选项 必须大于当前日期
    disabledDate: function disabledDate(t) {
      return new Date().getTime() < t.getTime();
    },
    onProbationDay: function onProbationDay(v) {
      this.handleProbation(v, this.dataForm.hire_date);
    },
    onHireDate: function onHireDate(v) {
      this.handleProbation(this.dataForm.probation_day, v);
    },
    handleProbation: function handleProbation(v, hire) {
      // 填写了“试用期(天)”，自动计算：转正日期=入职日期+试用期(天)——入职日期为第0天
      if (!String(v)) return;
      var day = Number(v);
      var hireData = new Date(hire);
      hireData.setDate(hireData.getDate() + day);
      this.dataForm.formal_date = this.formatDay(hireData);
    },
    // 时间戳转换为日期 2020-09-08
    formatDay: function formatDay(timestamp) {
      var date = new Date(timestamp);
      var YY = date.getFullYear();
      var MM = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      return "".concat(YY, "-").concat(MM, "-").concat(DD);
    },
    handlerChangeCallType: function handlerChangeCallType(params) {
      // 称谓同步
      this.dataForm.call_type_en = params;
    },
    changeDormal: function changeDormal(v) {
      var _this3 = this;
      // 修改转正日期
      var newTime = new Date().getTime();
      var selectTime = new Date(v).getTime();
      if (selectTime < newTime && this.dataForm.formal_date) {
        var h = this.$createElement;
        var formal_state;
        this.$msgbox({
          title: this.$t('229'),
          message: h(UpdateProbationRadio, {
            // see https://github.com/ElemeFE/element/issues/8931
            key: uuidv4(),
            on: {
              change: function change(v) {
                formal_state = v;
              }
            }
          }),
          distinguishCancelAndClose: true,
          showCancelButton: true,
          confirmButtonText: this.$t('131'),
          cancelButtonText: this.$t('66'),
          customClass: 'probation-msg-box'
        }).then(function () {
          _this3.dataForm.formal_state = formal_state;
          if (formal_state === '1') {
            _this3.dataForm.formal_date = _this3.cDataForm.formal_date || _this3.dataForm.formal_date;
          }
          inviteApproval(_objectSpread(_objectSpread({}, _this3.dataForm), {}, {
            state: 1
          })).then(function (res) {
            _this3.dataForm = {};
            _this3.visible = false;
            _this3.$refs.dataForm.resetFields();
            _this3.$emit('handleGetPendingList');
          });
        }).catch(function (action) {
          // if (action === 'close') return
          // this.dataForm.formal_date = this.cDataForm.formal_date || this.dataForm.formal_date
          // this.dataForm.formal_state = '1'
          // inviteApproval({ ...this.dataForm, state: 1 }).then(res => {
          //   this.dataForm = {}
          //   this.visible = false
          //   this.$refs.dataForm.resetFields()
          //   this.$emit('handleGetPendingList')
          // })
        });
      } else {
        inviteApproval(_objectSpread(_objectSpread({}, this.dataForm), {}, {
          state: 1
        })).then(function (res) {
          _this3.dataForm = {};
          _this3.visible = false;
          _this3.$refs.dataForm.resetFields();
          _this3.$emit('handleGetPendingList');
        });
      }
    },
    handleNodeClick: function handleNodeClick(val) {
      this.dataForm.department_name = val.department_name;
      this.dataForm.department_id = val.department_id;
      this.popover = false;
    },
    handleInviteApproval: function handleInviteApproval() {
      var _this4 = this;
      this.$refs.dataForm.validate(function (valid) {
        if (valid) {
          _this4.changeDormal(_this4.dataForm.formal_date);
        }
      });
    }
  }
};